<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.02429 10.2708C8.49123 10.9105 7.50876 10.9105 6.9757 10.2708L3.91121 6.59346C3.54937 6.15924 3.85814 5.5 4.42336 5.5H11.5766C12.1419 5.5 12.4506 6.15924 12.0888 6.59346L9.02429 10.2708Z" fill="currentColor" />
  </svg>
</template>
